import IserbaModal from "components/shared/iserba/IserbaModal";
import React from "react";

const SplashScreen = ({
	title,
	text,
	situation,
	items,
	onStart,
	itemsLabel = "Équipements à disposition :",
}) => {
	return (
		<>
			<IserbaModal isOpen={true}>
				<div className="flex flex-col items-center justify-center h-fit">
					<p className="text-gray-600 mb-1 text-xs text-center italic">
						{title}
					</p>
					<p className="text-gray-600 mb-4 text-lg font-bold text-center">
						{text}
					</p>

					{situation && (
						<img
							alt="situation"
							src={situation}
							className="max-w-full max-h-48 object-contain mb-4"
						/>
					)}

					{items && items.length > 0 && (
						<>
							<p className="text-gray-600 font-bold text-center mb-1">
								{itemsLabel}
							</p>

							<div className="flex gap-2 overflow-scroll w-full pr-4 pb-2 ">
								{[...items].map((item, index) => (
									<div
										key={index}
										className="bg-gray-200 rounded-xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] flex flex-col min-w-28 w-28 h-[80px] overflow-hidden items-center justify-center"
									>
										<div
											className="bg-contain bg-no-repeat bg-center min-h-[40px] min-w-12 h-[40px] w-12 max-h-[40px] max-w-12 p-1"
											style={{
												backgroundImage: item.icon
													? `url(${item.icon})`
													: "none",
											}}
										/>
										<div className="text-xs text-gray-700 uppercase text-center w-28 whitespace-pre-wrap">
											{item.name}
										</div>
									</div>
								))}
							</div>
						</>
					)}

					<button
						onClick={onStart}
						className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
					>
						Jouer
					</button>
				</div>
			</IserbaModal>
		</>
	);
};

export default SplashScreen;
